export default "/right-nav-arrow.a6f41194c6a298e68579ec0bd7b31eaa.svg";